var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChoose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark-Pink-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 21.3335,
    y: 21.7764,
    width: 21.3333,
    height: 21.3333,
    rx: 5.33333,
    fill: "url(#paint0_linear_478_4225)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_478_4225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 13.7762C25.4726 13.7762 26.6665 12.5823 26.6665 11.1095C26.6665 9.63678 25.4726 8.44287 23.9998 8.44287H18.6665C12.7755 8.44287 7.99984 13.2185 7.99984 19.1095V24.4429C7.99984 25.9156 9.19374 27.1095 10.6665 27.1095C12.1393 27.1095 13.3332 25.9156 13.3332 24.4429V19.1095C13.3332 16.164 15.721 13.7762 18.6665 13.7762H23.9998Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 13.7762C25.4726 13.7762 26.6665 12.5823 26.6665 11.1095C26.6665 9.63678 25.4726 8.44287 23.9998 8.44287H18.6665C12.7755 8.44287 7.99984 13.2185 7.99984 19.1095V24.4429C7.99984 25.9156 9.19374 27.1095 10.6665 27.1095C12.1393 27.1095 13.3332 25.9156 13.3332 24.4429V19.1095C13.3332 16.164 15.721 13.7762 18.6665 13.7762H23.9998Z",
    fill: "url(#paint1_linear_478_4225)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 45.7762V37.7762H50.6665V45.7762C50.6665 48.7217 48.2787 51.1095 45.3332 51.1095H39.9998C38.5271 51.1095 37.3332 52.3034 37.3332 53.7762C37.3332 55.249 38.5271 56.4429 39.9998 56.4429H45.3332C51.2242 56.4429 55.9998 51.6672 55.9998 45.7762V37.7762H58.6665C60.1393 37.7762 61.3332 36.5823 61.3332 35.1095C61.3332 33.6368 60.1393 32.4429 58.6665 32.4429H5.33317C3.86041 32.4429 2.6665 33.6368 2.6665 35.1095C2.6665 36.5823 3.86041 37.7762 5.33317 37.7762H7.99984V45.7762C7.99984 51.6672 12.7755 56.4429 18.6665 56.4429H23.9998C25.4726 56.4429 26.6665 55.249 26.6665 53.7762C26.6665 52.3034 25.4726 51.1095 23.9998 51.1095H18.6665C15.721 51.1095 13.3332 48.7217 13.3332 45.7762Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 45.7762V37.7762H50.6665V45.7762C50.6665 48.7217 48.2787 51.1095 45.3332 51.1095H39.9998C38.5271 51.1095 37.3332 52.3034 37.3332 53.7762C37.3332 55.249 38.5271 56.4429 39.9998 56.4429H45.3332C51.2242 56.4429 55.9998 51.6672 55.9998 45.7762V37.7762H58.6665C60.1393 37.7762 61.3332 36.5823 61.3332 35.1095C61.3332 33.6368 60.1393 32.4429 58.6665 32.4429H5.33317C3.86041 32.4429 2.6665 33.6368 2.6665 35.1095C2.6665 36.5823 3.86041 37.7762 5.33317 37.7762H7.99984V45.7762C7.99984 51.6672 12.7755 56.4429 18.6665 56.4429H23.9998C25.4726 56.4429 26.6665 55.249 26.6665 53.7762C26.6665 52.3034 25.4726 51.1095 23.9998 51.1095H18.6665C15.721 51.1095 13.3332 48.7217 13.3332 45.7762Z",
    fill: "url(#paint2_linear_478_4225)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 27.1095C51.8604 27.1095 50.6665 25.9156 50.6665 24.4429V19.1095C50.6665 16.164 48.2787 13.7762 45.3332 13.7762H39.9998C38.5271 13.7762 37.3332 12.5823 37.3332 11.1095C37.3332 9.63678 38.5271 8.44287 39.9998 8.44287H45.3332C51.2242 8.44287 55.9998 13.2185 55.9998 19.1095V24.4429C55.9998 25.9156 54.8059 27.1095 53.3332 27.1095Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 27.1095C51.8604 27.1095 50.6665 25.9156 50.6665 24.4429V19.1095C50.6665 16.164 48.2787 13.7762 45.3332 13.7762H39.9998C38.5271 13.7762 37.3332 12.5823 37.3332 11.1095C37.3332 9.63678 38.5271 8.44287 39.9998 8.44287H45.3332C51.2242 8.44287 55.9998 13.2185 55.9998 19.1095V24.4429C55.9998 25.9156 54.8059 27.1095 53.3332 27.1095Z",
    fill: "url(#paint3_linear_478_4225)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 37.5095H13.0665V37.7762V45.7762C13.0665 48.869 15.5737 51.3762 18.6665 51.3762H23.9998C25.3253 51.3762 26.3998 52.4507 26.3998 53.7762C26.3998 55.1017 25.3253 56.1762 23.9998 56.1762H18.6665C12.9227 56.1762 8.2665 51.52 8.2665 45.7762V37.7762V37.5095H7.99984H5.33317C4.00769 37.5095 2.93317 36.435 2.93317 35.1095C2.93317 33.7841 4.00769 32.7095 5.33317 32.7095H58.6665C59.992 32.7095 61.0665 33.7841 61.0665 35.1095C61.0665 36.435 59.992 37.5095 58.6665 37.5095H55.9998H55.7332V37.7762V45.7762C55.7332 51.52 51.0769 56.1762 45.3332 56.1762H39.9998C38.6744 56.1762 37.5998 55.1017 37.5998 53.7762C37.5998 52.4507 38.6744 51.3762 39.9998 51.3762H45.3332C48.426 51.3762 50.9332 48.869 50.9332 45.7762V37.7762V37.5095H50.6665H13.3332ZM26.3998 11.1095C26.3998 12.435 25.3253 13.5095 23.9998 13.5095H18.6665C15.5737 13.5095 13.0665 16.0167 13.0665 19.1095V24.4429C13.0665 25.7684 11.992 26.8429 10.6665 26.8429C9.34102 26.8429 8.2665 25.7684 8.2665 24.4429V19.1095C8.2665 13.3658 12.9227 8.70954 18.6665 8.70954H23.9998C25.3253 8.70954 26.3998 9.78405 26.3998 11.1095ZM53.3332 26.8429C52.0077 26.8429 50.9332 25.7684 50.9332 24.4429V19.1095C50.9332 16.0167 48.426 13.5095 45.3332 13.5095H39.9998C38.6744 13.5095 37.5998 12.435 37.5998 11.1095C37.5998 9.78405 38.6744 8.70954 39.9998 8.70954H45.3332C51.0769 8.70954 55.7332 13.3658 55.7332 19.1095V24.4429C55.7332 25.7684 54.6587 26.8429 53.3332 26.8429Z",
    stroke: "url(#paint4_linear_478_4225)",
    strokeOpacity: 0.1,
    strokeWidth: 0.533333
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_478_4225",
    x: -0.333496,
    y: 5.44287,
    width: 64.6665,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_478_4225"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_478_4225",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_478_4225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_478_4225",
    x1: 22.2224,
    y1: 26.043,
    x2: 45.4775,
    y2: 29.2729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_478_4225",
    x1: 5.11095,
    y1: 18.0429,
    x2: 68.4704,
    y2: 28.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_478_4225",
    x1: 5.11095,
    y1: 18.0429,
    x2: 68.4704,
    y2: 28.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_478_4225",
    x1: 5.11095,
    y1: 18.0429,
    x2: 68.4704,
    y2: 28.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_478_4225",
    x1: 4.49984,
    y1: 10.6247,
    x2: 61.3332,
    y2: 10.6247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose);
export default __webpack_public_path__ + "static/media/choose.9918d0af7f14da119869cddfcd2ee191.svg";
export { ForwardRef as ReactComponent };